import React from 'react';

import { range } from './util';

import s from './StarRating.module.css';

type TProps = {
  emptyColor: string;
  emptyStrokeColor?: string;
  fillColor: string;
  fillStrokeColor?: string;
  height?: number;
  max?: number;
  value: number;
  width?: number;
};

export const calcFillPercentage = (i: number, value: number) => {
  const df = i - value;

  if (df <= 0) {
    return 100;
  }

  if (df >= 1) {
    return 0;
  }

  return (1 - df) * 100;
};

export const StarRating = ({
  emptyColor,
  emptyStrokeColor,
  fillColor,
  fillStrokeColor,
  height = 23,
  max = 5,
  value,
  width = 23,
}: TProps) => {
  return (
    <div className={s.stars}>
      {range(1, max + 1).map((i: number) => {
        const id = i;
        const fillPercentage = calcFillPercentage(i, value);

        let color;
        let strokeColor = fillStrokeColor;
        let drawGradient = false;

        if (fillPercentage === 100) {
          color = fillColor;
        } else if (fillPercentage === 0) {
          color = emptyColor;
          strokeColor = emptyStrokeColor;
        } else {
          drawGradient = true;
          color = `url(#star-${id})`;
        }

        return (
          <svg
            className={s.star}
            viewBox="0 0 39 38"
            key={i}
            width={width}
            height={height}
          >
            {drawGradient ? (
              <defs>
                <linearGradient id={`star-${id}`} stroke="red">
                  <stop offset={`${fillPercentage}%`} stopColor={fillColor} />
                  <stop stopColor={emptyColor} />
                </linearGradient>
              </defs>
            ) : null}
            <path
              d="M19.4757 0L24.0728 14.1484H38.9493L26.914 22.8926L31.5111 37.041L19.4757 28.2968L7.4404 37.041L12.0375 22.8926L0.0021534 14.1484H14.8786L19.4757 0Z"
              fill={color}
              stroke={strokeColor}
            />
          </svg>
        );
      })}
    </div>
  );
};
